<template>
  <div>
    <p class="mb-0 text--small text--bold">
      {{ $t('subscriptions.views.SubscriptionConsumption.DataroomStorage.Dialog.packageOverchargeAuthorized') }}
    </p>

    <div class="d-flex justify-space-between align-center">
      <p class="text--small">
        <i18n-t keypath="subscriptions.views.SubscriptionConsumption.DataroomStorage.Dialog.packageOverchargePriceByGo"
                tag="span"
                scope="global"
        >
          <template #price>
            {{ currentStorageOverchargePrice }}
          </template>
        </i18n-t>
      </p>
      <v-switch v-model="isStorageOverchargeEnabled"
                hide-details
      >
      </v-switch>
    </div>

    <!-- Volume -->
    <template v-if="isStorageOverchargeEnabled">
      <v-divider></v-divider>
      <AppTextField id="signers-name"
                    v-model.number="storageOvercharge"
                    class="mt-6"
                    :label="$t('subscriptions.views.SubscriptionConsumption.DataroomStorage.Dialog.setVolume')"
                    type="number"
                    min="0"
                    suffix="Go"
                    autofocus
                    style="max-width: 155px"
      />
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  import AppTextField from '@/common/AppTextField.vue'

  export default {
    name: 'SubscriptionDataroomStorageOverchargeManagement',
    components: { AppTextField },
    data () {
      return {
        isStorageOverchargeEnabled: false,
        storageOvercharge: 0,
      }
    },
    computed: {
      ...mapState('subscription', ['subscriptionDataroomStorage']),
      currentStorageOverchargePrice () {
        const overchargePrice = parseInt(this.subscriptionDataroomStorage.currentTotalPriceGb) / parseInt(this.subscriptionDataroomStorage.limitGb)
        return parseInt(overchargePrice)
      },
    },
    watch: {
      isStorageOverchargeEnabled (newVal) {
        if (!newVal) {
          this.storageOvercharge = 0
        }
      },
      storageOvercharge (newVal) {
        this.$emit('set-storage-overchage', newVal)
      },
    },
    created () {
      this.storageOvercharge = parseFloat(this.subscriptionDataroomStorage.limitGbOvercharge)
      if (this.storageOvercharge > 0) {
        this.isStorageOverchargeEnabled = true
      }
    },
  }
</script>
